<template>
  <svg xmlns="http://www.w3.org/2000/svg"
       :width="width"
       :height="height"
       viewBox="0 0 36 36"
       role="presentation"
       @click="$emit('click')">
    <g :fill="disabled ? disabledStateColor : iconColor">
      <path d="M21.092 11.602l-8.546 8.28c-.487-.88-.788-1.873-.788-2.944 0-3.407 2.8-6.18 6.242-6.18 1.13 0 2.178.321 3.092.844zM14.52 22.065l8.724-8.453a6.08 6.08 0 0 1 .998 3.325c0 3.408-2.8 6.18-6.242 6.18a6.244 6.244 0 0 1-3.48-1.052zm3.48 3.98c5.073 0 9.198-4.086 9.198-9.108 0-5.021-4.125-9.105-9.198-9.105s-9.198 4.084-9.198 9.105c0 5.022 4.125 9.107 9.198 9.107zM32.245 5.883c.615 4.236.862 10.415.713 13.707-.186 3.813-2.38 7.293-5.827 8.954a33.265 33.265 0 0 0-2.972 1.637c-2.572 1.586-4.62 3.284-5.616 4.551a.686.686 0 0 1-1.087 0c-.995-1.267-3.044-2.965-5.614-4.551a33.461 33.461 0 0 0-2.972-1.637c-3.448-1.661-5.641-5.14-5.827-8.954-.15-3.292.097-9.471.712-13.707.11-.758.82-1.245 1.581-1.15 4.495.563 8.373-.568 11.746-3.396.536-.45 1.3-.45 1.837 0 3.372 2.828 7.25 3.96 11.744 3.395.764-.094 1.472.393 1.582 1.151z"/>
    </g>
  </svg>
</template>

<script>
  import iconMixin from './iconMixin.js'

  export default {
    mixins: [iconMixin]
  }
</script>
